import React from 'react';
import { AlertTriangle, Clock, Shield, Activity, Target, Crosshair, TrendingUp, TrendingDown } from 'lucide-react';
import { KEY_METRICS } from '../mitre-data';

export default function KeyMetrics() {
  const metrics = [
    {
      title: 'Total Incidents',
      value: KEY_METRICS.totalIncidents.toLocaleString(),
      change: '-12% from last month',
      trend: 'good',
      icon: AlertTriangle,
      color: 'red',
    },
    {
      title: 'MITRE Tactics Hit',
      value: `${KEY_METRICS.mitreTacticsHit}/12`,
      change: `${KEY_METRICS.techniquesCovered} techniques tracked`,
      trend: 'neutral',
      icon: Target,
      color: 'orange',
    },
    {
      title: 'Avg Detection Time',
      value: KEY_METRICS.avgDetectTime,
      change: '-18% from last month',
      trend: 'good',
      icon: Clock,
      color: 'blue',
    },
    {
      title: 'Threats Blocked',
      value: KEY_METRICS.threatsBlocked.toLocaleString(),
      change: '+23% from last month',
      trend: 'good',
      icon: Shield,
      color: 'green',
    },
    {
      title: 'Critical Open',
      value: String(KEY_METRICS.criticalOpen),
      change: '-4 from last month',
      trend: 'good',
      icon: Crosshair,
      color: 'red',
    },
    {
      title: 'Posture Score',
      value: `${KEY_METRICS.postureScore}%`,
      change: '+3% from last month',
      trend: 'good',
      icon: Activity,
      color: 'green',
    },
  ];

  return (
    <div className="key-metrics">
      {metrics.map((metric, index) => {
        const IconComponent = metric.icon;
        const TrendIcon = metric.trend === 'bad' ? TrendingDown : TrendingUp;
        const trendColor = metric.trend === 'neutral' ? 'neutral' : 'green';

        return (
          <div key={index} className="metric-card">
            <div className="metric-card__content">
              <div className="metric-card__info">
                <p className="metric-card__label">{metric.title}</p>
                <p className="metric-card__value">{metric.value}</p>
                <div className={`metric-card__change metric-card__change--${trendColor}`}>
                  {metric.trend !== 'neutral' && <TrendIcon size={12} />}
                  <span>{metric.change}</span>
                </div>
              </div>
              <div className={`metric-card__icon metric-card__icon--${metric.color}`}>
                <IconComponent size={28} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
